import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { savePostLoginRedirect } from "@/lib/postLoginRedirect";
import { VideoJobNotifier } from "@/components/documentos/ia/VideoJobNotifier";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    // Guarda o destino para voltar a ele depois do login (link de e-mail).
    savePostLoginRedirect(`${location.pathname}${location.search}`);
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {/* Aviso de vídeo do "Criar com IA" concluído, em qualquer tela (D1). */}
      <VideoJobNotifier />
      {children}
    </>
  );
}
